<!--
  @Description: 直播频道
  @Author: wang.y 
  @Date: 2022-05-12 
-->
<template>
  <div>
    <!-- banner -->
    <div class="banner">
      <swiper :options="swiper_option" ref="swiper" v-if="banner1.length">
        <swiper-slide v-for="item,index in banner1" :key="index" class="stop-swiping">
          <a class="banner-item" :href="item.link">
            <img :src="item.imgPath | logo_show" @click="addPuv(item.uid)">
          </a>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 视频列表 -->
    <div class="news-content">
      <div :class="{'space-between-tabs': last_live, 'space-around-tabs': !last_live}" class="common-tabs">
        <span :class="{'active': active == 1}" @click="changeTab(1)" v-if="last_live">最新直播</span>
        <span v-for="tab, index in tabs_list" :key="tab.id" :class="{'active': active == tab.id}" @click="changeTab(tab.id)"
        >{{tab.name}}</span>
      </div>
      <LiveList :data="list" v-if="active == 1"></LiveList>
      <div class="fore-content" v-if="active == 2">
        <div class="fore-li" v-for="item, index in list" :key="index" @click="getliveurl(item)">
          <div class="time">{{item.aliveStartAt | time_moment_second}} - {{item.aliveStopAt | time_moment_hour}}</div>
          <div class="info">{{item.title}}</div>
        </div>
      </div>
      <LiveList :data="list" v-if="active == 3"></LiveList>
      <div class="news-li" v-for="item, index in list" :key="index" v-if="active == 4">
        <div class="left" @click="toArticle(item)">
          <img :src="item.logoPath | logo_show" />
        </div>
        <div class="right">
          <h1 @click="toArticle(item)">{{item.title}}</h1>
          <div class="desc">
            <span class="author">{{item.authorName}}</span>
            <span class="time">{{item.publishTime | time_standard}}</span>
          </div>
        </div>
      </div>

      <Spin v-if="more_loading">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      </Spin>
    </div>
  </div>
</template>
<script>
import { getBanner, getMeta, onlinearticlelist, addPuv, liveList, liveurl } from '@/service'
import LiveList from './components/LiveList.vue'
export default {
  components: { LiveList },
  data() {
    return {
      banner1: [],
      articleList: [],
      params: {
        page: 1,
        size: 20,
      },
      tabs_list: [
        // {
        //   id: 1,
        //   name: '最新直播',
        // },
        {
          id: 3,
          name: '精彩回放',
        },
        {
          id: 4,
          name: '相关文章',
        },
      ],
      active: 1,
      more_loading: false,
      banner_loading: false,
      is_last: false,
      list: [], //预告列表
      tab: 'tab1',
      is_more: true,
      page: 1,
      last_live: true, //是否有最新直播
    }
  },
  computed: {
    swiper_option() {
      return {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      }
    },
  },
  created() {
    this.getMeta()
    this.getBanner()
    this.liveList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        if (scrollTop > scrollHeight - windowHeight - 240 && !this.more_loading && scrollTop > 0 && this.is_more) {
          this.more()
        }
      })
    })
  },
  methods: {
    getliveurl(item) {
      window.open(item.h5Url)
    },
    changeTab(id) {
      this.active = id
      this.list = []
      if (this.active == 4) {
        this.params.page = 1
        this.indexlist()
      } else {
        this.page = 1
        this.liveList()
      }
    },
    toArticle(a) {
      const href = this.$store.state.index2_path + '/' + a.id
      window.open(href)
    },
    async addPuv(uid) {
      let res = await addPuv({
        url: 'https://www.vbdata.cn/advClick?uid=' + uid,
      })
    },

    /**
     * @description: 栏目元数据
     * @param {*}
     * @return {*}
     */
    async getMeta() {
      let res = await getMeta(
        {
          name: ['article_category', 'entity_ntag', 'media_tag'],
        },
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'article_category', res.meta.article_category)
        this.$set(this.$data, 'entity_ntag', res.meta.entity_ntag)
        this.$set(this.$data, 'media_tag', res.meta.media_tag)
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 广告位
     * @param {*}
     * @return {*}
     */
    async getBanner() {
      let res = await getBanner(
        {
          position_id: ['59', '60', '61', '62', '63'],
        },
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        res.data.forEach((item) => {
          this.banner1.push(item)
        })
        this.banner_loading = false
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 文章列表
     * @param {*}
     * @return {*}
     */
    async indexlist() {
      this.more_loading = true
      let res = await onlinearticlelist(
        { ...this.params, ...{ user_key: this.$store.state.user_key } },
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      this.more_loading = false
      if (res.code == 0) {
        if (this.params.page == 1) {
          this.list = [...res.data.topList, ...res.data.list]
        } else {
          this.list = [...this.list, ...res.data.list]
        }
        this.is_more = res.data.list.length == this.params.size
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * 小鹅通最新直播列表
     */
    async liveList() {
      this.more_loading = true
      let param = {
        pageSize: 10,
        page: this.page
      }
      if (this.active == 1) param.scene = 1
      else if (this.active == 3) param.scene = 2
      else if (this.active == 2) param.scene = 3
      let res = await liveList(
        param,
        (error) => {
          this.$message.error('请求错误！')
        }
      )
      if (res.success) {
        this.is_more = res.data.list.length == 10
        if (this.page == 1 && this.active == 1 && res.data.list.length == 0) {
          this.last_live = false
          this.changeTab(3)
        }
        this.list = [...this.list, ...res.data.list]
        this.more_loading = false
      } else {
        this.$message.error(res.msg)
      }
    },
    /**
     * @description: 加载更多
     * @param {*}
     * @return {*}
     */
    more() {
      if (this.active == 4) {
        ++this.params.page
        this.indexlist()
      } else {
        ++this.page
        this.liveList()
      }
    },
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.banner
  padding-top 14px
  >>>.swiper-container
    width: calc(100vw - 28px)
    height: calc((100vw - 28px) * 0.6461)
    margin: 0 auto
    .banner-item
      img
        width 100%
        height 100%
.news-content
  padding 0.28rem 0.4rem 0.5rem
  .space-between-tabs
    justify-content space-between
  .space-around-tabs
    justify-content space-around
  .common-tabs
    display flex
    margin-bottom 0.36rem
    span
      font-size 0.26rem
      font-weight 500
      color #666666
      line-height 0.6rem
    .active
      color #FA5A00
      border-bottom 0.04rem solid #FA5A00
.news-li
  display flex
  justify-content space-between
  margin-top 0.5rem
  .left
    height 1.44rem
    width 2rem
    img
      width 100%
      height 100%
  .right
    flex 1
    margin-left 0.16rem
    h1
      overflow hidden
      display -webkit-box
      -webkit-line-clamp 2
      -webkit-box-orient vertical
      font-size 0.32rem
      line-height 0.4rem
      color #424141
      height 0.8rem
      text-overflow ellipsis
    .desc
      font-size 0.28rem
      color #CFCFCF
      margin-top 0.32rem
    .author
      color #FA5A00
      margin-right 0.2rem
  &:first-child
    margin-top 0
.fore-content
  border-left 0.01rem solid #AAD0FF
.fore-li
  .time
    height 0.32rem
    padding 0.06rem
    color #FFFFFF
    font-size 0.26rem
    width fit-content
    background linear-gradient(90deg, #0168EC, #00A2F5)
  .info
    font-size 0.28rem
    color #333333
    line-height 0.42rem
    text-align justify
    margin 0.36rem 0 0.48rem 0.26rem
>>>.ivu-spin
  color #ddd
  margin-top 0.3rem
  .ivu-spin-dot
    background-color #ddd
</style>